<!-- Leftside panel starts here -->

<div class="left-section filter">
  <div class="form-row nav flex-column p-1">
    <div class="wrapper">
      <div class="main-part">
        <button
          mat-button
          class="btn btn-apply"
          type="button"
          [disabled]="
            selectedStates.length === 0 ||
            selectedTopics.length === 0 ||
            loading === true
          "
          (click)="onRegCompare()"
        >
          Apply
        </button>
      </div>
      <div class="minor-part">
        <button mat-button class="clear-all" (click)="ClearAll()">
          Clear All
        </button>
      </div>
    </div>

    <div class="cheader">
      <div class="d-flex justify-content-between box-header text-white">
        <div>
          <p class="triangle-bottomleft">
            <span class="fa fa-search mr-2" aria-hidden="true"></span>Compare
          </p>
        </div>
        <div class="align-self-end p-2">
          <mat-icon class="help-info" (click)="openHelpInfo($event, 17)"
            >info</mat-icon
          >
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between box-header text-white mb-1">
      <div class="triangle-bottomleft-remove compare-header">
        <mat-icon class="fa fa-info-circle pointer">filter_alt</mat-icon>&nbsp;
        Filter
      </div>
    </div>

    <div id="accordJur" class="position-relative" #accordJur>
      <div header="Jurisdiction" class="pointer-none">
        <div class="ui-accordion-header ui-state-default ui-corner-all">
          <div class="panel-body pt-0 button-bar" (click)="showJurPopup()">
            <div class="p-0 rc-item">
              <p>Jurisdictions</p>
              <div class="icon-right">
                <mat-icon
                  class="viewall icon-right fa-flag f-size-14 flag-info"
                  [hidden]="selectedStates.length == 0"
                  >check</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (selectedStates.length > 0) {
        <div class="chosen-item">
          <p>{{ selectedStates.join(", ") }}</p>
          <button
            button
            mat-button
            class="button-action"
            (click)="ClearJurisdiction()"
          >
            Clear
          </button>
        </div>
      }
    </div>

    <div id="accordTopic" class="position-relative" #accordTopic>
      <div header="Topic" class="pointer-none">
        <div class="ui-accordion-header ui-state-default ui-corner-all">
          <div class="panel-body pt-0 button-bar" (click)="showTopicPopup()">
            <div class="p-0 rc-item">
              <p>Topics</p>
              <div class="icon-right">
                <mat-icon
                  class="viewall icon-right fa-flag f-size-14 flag-info"
                  [hidden]="selectedTopics.length == 0"
                  >check</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (selectedTopics.length > 0) {
        <div class="chosen-item">
          <ul>
            @for (tp of selectedTopics; track tp; let i = $index) {
              @if (i < 16) {
                <li
                  (click)="filterTopic(tp)"
                  class="clickable"
                  [ngClass]="filteredTopic === tp ? 'filteredTopic' : ''"
                >
                  {{ tp }}
                </li>
              }
              @if (i === 16) {
                <li>...</li>
              }
            }
          </ul>
          <button mat-button class="button-action" (click)="ClearTopic()">
            Clear
          </button>
        </div>
      }
    </div>

    <div class="d-flex justify-content-between box-header text-white mb-1">
      <div
        class="triangle-bottomleft-remove compare-header"
        [ngClass]="this.selectedComparisonId == 0 ? 'disable' : 'runnable'"
      >
        <mat-icon
          class="fa fa-info-circle pointer"
          [ngClass]="this.selectedComparisonId == 0 ? 'disable' : 'runnable'"
          >restore</mat-icon
        >&nbsp; Run a Saved Comparison
      </div>
    </div>

    <mat-accordion id="accordSaved" class="position-relative" #accordSaved>
      <mat-expansion-panel (opened)="openComparisonDef()">
        <mat-expansion-panel-header
          class="ui-accordion-header ui-state-default ui-corner-all"
        >
          <mat-panel-title class="panel-body pt-0">
            Saved Comparisons
          </mat-panel-title>
        </mat-expansion-panel-header>
        <input
          id="SavedSearchName"
          type="text"
          class="form-control form-control-sm mt-2 mb-1 input-lg"
          placeholder="Search ..."
          [(ngModel)]="searchWord"
          (input)="onSearchComparison($event.target.value)"
        />
        <div>
          <mat-radio-group>
            @for (cd of displayDef; track cd; let i = $index) {
              <div class="saved-search-item">
                <mat-radio-button
                  class="radiobutton"
                  [name]="cd.comparisonName"
                  [checked]="isComparisonSelected(cd.id)"
                  [value]="cd.id"
                  (change)="onComparisonSelected(cd.id)"
                  >{{ cd.comparisonName }}</mat-radio-button
                >
                <div class="search-details">
                  <mat-icon
                    class="deleteButton material-icons-outlined"
                    (click)="onDeleteComparison(cd.id, cd.comparisonName)"
                    matTooltip="Delete saved comparison"
                    >delete</mat-icon
                  >
                </div>
              </div>
            }
          </mat-radio-group>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
